var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChairFurniture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#895129"
    },
    d: "M362.4,304h9.6c17.6,0,32,14.4,32,32v24c0,17.6-14.4,32-32,32h-16H156h-16c-17.6,0-32-14.4-32-32v-24 c0-17.6,14.4-32,32-32h10.8H362.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 392,
    style: {
      fill: "#5D4037"
    },
    width: 16,
    height: 116
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD8150"
    },
    d: "M292.8,4c52.8,0,92.4,43.2,87.6,95.6L362.8,304h-212L133.2,99.6C128.8,47.2,168,4,220.8,4H292.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 392,
    style: {
      fill: "#5D4037"
    },
    width: 16,
    height: 116
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.8,308c-2,0-4-1.6-4-3.6L129.2,100c-2.4-26.4,6-51.6,23.2-70.8C169.6,10.4,194,0,220.8,0h72c26.8,0,50.8,10.4,68.4,29.6 c17.2,18.8,25.6,44,23.2,70.4l-17.6,204.4c0,2-2,4-4.4,3.6c-2,0-4-2-3.6-4.4l17.6-204.4c2-24.4-5.6-47.2-21.2-64.4 c-16-17.2-38-26.8-62.4-26.8h-72c-24.4,0-46.4,9.6-62.4,26.8c-16,17.2-23.6,40-21.2,64.4l17.6,204.4 C154.8,306,153.2,307.6,150.8,308L150.8,308z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156,512h-16c-2.4,0-4-1.6-4-4V392c0-2.4,1.6-4,4-4s4,1.6,4,4v112h8V392c0-2.4,1.6-4,4-4s4,1.6,4,4v116 C160,510.4,158.4,512,156,512z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M372,512h-16c-2.4,0-4-1.6-4-4V392c0-2.4,1.6-4,4-4s4,1.6,4,4v112h8V392c0-2.4,1.6-4,4-4s4,1.6,4,4v116 C376,510.4,374.4,512,372,512z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M372,396H140c-20,0-36-16-36-36v-24c0-20,16-36,36-36h232c20,0,36,16,36,36v24C408,380,392,396,372,396z M140,308 c-15.6,0-28,12.4-28,28v24c0,15.6,12.4,28,28,28h232c15.6,0,28-12.4,28-28v-24c0-15.6-12.4-28-28-28H140z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272,28h-20c-2.4,0-4-1.6-4-4s1.6-4,4-4h20c2.4,0,4,1.6,4,4S274.4,28,272,28z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.4,188c-2,0-3.6-1.6-4-3.6l-2.4-28c0-2.4,1.6-4,3.6-4.4c2.4-0.4,4,1.6,4.4,3.6l2.4,28C164.4,186,162.8,187.6,160.4,188 C160.8,188,160.4,188,160.4,188z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168.4,280c-2,0-4-1.6-4-3.6l-6.4-72c0-2.4,1.6-4,3.6-4.4s4,1.6,4.4,3.6l6.4,72C172.4,278,170.8,279.6,168.4,280 C168.8,280,168.4,280,168.4,280z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M343.2,49.6c-1.2,0-2-0.4-2.8-1.2c-12-13.2-28.8-20.4-47.6-20.4c-2.4,0-4-1.6-4-4s1.6-4,4-4c20.8,0,40,8,53.6,22.8 c1.6,1.6,1.2,4-0.4,5.6C345.2,49.2,344.4,49.6,343.2,49.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairFurniture);
export default __webpack_public_path__ + "static/media/chair-furniture.1909121293e460e4c38736298a12ac87.svg";
export { ForwardRef as ReactComponent };